import React from 'react'
import { Text } from 'components'
import classNames from 'classnames'
import Switch from 'react-switch'
import styles from './Toggle.module.scss'

const Toggle = ({
  option,
  optionPosition = 'left',
  checked = false,
  onChange,
  id = '',
}) => (
  // eslint-disable-next-line jsx-a11y/label-has-for
  <label
    htmlFor={id}
    className={classNames(styles.container, styles[`option-${optionPosition}`])}
  >
    <Text bold={checked}>{option}</Text>
    <Switch
      id={id}
      onChange={onChange}
      checked={checked}
      uncheckedIcon={false}
      checkedIcon={false}
      onColor="#0070c0"
      height={22}
      width={40}
    />
  </label>
)

export default React.memo(Toggle)
